import store from '@/store';

export default function Events() {
    const v = this;
    v.eventHandlers = {};
    v.emitter = store.state.display.emitter;
}

Events.prototype.on = function (name, handler) {
    const vm = this;
    this.eventHandlers[name] = handler;    
    this.emitter.on(name, this.eventHandlers[name]);
};
Events.prototype.off = function (name) {
    const vm = this;
    if (this.eventHandlers[name]) this.emitter.off(name, this.eventHandlers[name]);
    this.eventHandlers[name] = null;
}

Events.prototype.allOff = function (name) {
    const vm = this;
    Object.keys(this.eventHandlers).forEach(n => {
        this.emitter.off(n, this.eventHandlers[n])
    })
    this.eventHandlers[name] = {};
}

//vm.myEvents.apiDataAvailable(vm.tableState, vm.filter, vm.setValue);
Events.prototype.apiDataAvailable = function (tableState, filter, setValue) {
    const v = this;
    if (tableState.selections)
        setValue(
            tableState.selections[filter.field.name],
            'Initialize Event'
        );
    v.on('apiDataAvailable', function () {
        setValue(
            tableState.selections[filter.field.name],
            'Event'
        );
    });
}

//vm.myEvents = Events.initialize(vm.myEvents);
Events.initialize = function (events) {
    const v = this;
    if (!events) {
        return new Events();
    } else {
        events.allOff()
        return events;
    }
}

//this.myEvents = Events.kill(this.myEvents);
// beforeUnmount() {
//     this.myEvents = Events.kill(this.myEvents);
// }

Events.kill = function (events) {
    if (events) events.allOff();
    return null;
}
